import { Calendar } from '@tochka-modules/t15-ui-kit-icons-ssr/24/Stroked/Calendar';
import cn from 'classnames';
import { FormTextField } from 'components/form';
import { Spacer, Typo } from 'components/ui-kit';
import { useField } from 'formik';
import React from 'react';
import { ECertificateDeliveryMethod } from './certificate-form.const';
import styles from './certificate-form.module.scss';
import { TRecipientFieldsProps } from './certificate-form.types';

export const RecipientFields = ({
  emailError,
  dateError,
}: TRecipientFieldsProps): JSX.Element | null => {
  const [deliveryType] = useField('deliveryMethod');
  return (
    <div
      className={cn(styles.sendingFieldBlock, {
        [styles.opened]:
          deliveryType.value === ECertificateDeliveryMethod.email,
      })}
    >
      <Spacer size={32} />
      <Typo variant="xl" weight="600">
        Для кого
      </Typo>
      <Spacer size={8} />
      <Typo variant="l">
        Отправим подарочный сертификат на&nbsp;указанную почту с&nbsp;8
        до&nbsp;16 мск
      </Typo>
      <FormTextField
        type="email"
        label="Email получателя"
        name="toEmail"
        invalidMessage={emailError}
      />
      <Spacer size={16} />
      <FormTextField
        label="Дата отправки письма"
        mask="99.99.9999"
        accessor={<Calendar />}
        name="deliveryDate"
        invalidMessage={dateError}
      />
    </div>
  );
};
